module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/H4e3Ea/tc-custom/9781504061582.jpg?1705635374871",
      "alt": "This image is the cover for the book Last Trumpet, The Hugh Rennert Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Trumpet, The Hugh Rennert Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this Mexico-set mystery with “excellent atmosphere” featuring a sheriff and an amateur sleuth, a bullfighter is dead—but was the killer man or beast ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(")?")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In Matamoras, Mexico, the last trumpet has sounded in the bullring, but this time it’s not the bull who’s died. Carlos Campos has been fatally gored. But soon a shocking discovery is made: the apparent accident is actually a murder . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" To solve the case, former US Customs agent and Texas citrus farmer Hugh Rennert will team up with Sheriff Peter Bounty to identify a motive and a suspect. And there’s no time to lose as the killer hasn’t limited himself to a single victim . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “You won’t go wrong in giving Todd Downing a try.” —Michael Dirda, "), _c('i', [_vm._v("The Washington Post")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Todd Downing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Todd Downing, Oklahoma’s first successful writer of detective novels, was born at Atoka, Indian Territory (now Oklahoma), in 1902. His paternal grandmother, Millissa Armstrong, part of the 1830 Choctaw migration from Mississippi, was George T. Downing’s second wife. Their son, Samuel, Todd’s father, born in the Choctaw Nation in 1872, served in Troop M of the Rough Riders, and married Maude Miller in 1899.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    MysteriousPress.com/Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0